import { Container } from "@movicoders/di";
import { IRepository } from "@movicoders/domain";
import { DomainPage } from "@movicoders/domain/lib/Entities/DomainPage";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useResourceContext } from "../../Resources";

import {
  GetImplementedSearchPaginatedType,
  GetImplementedEntityType,
  GetImplementedSearchType,
  ObjectType,
} from "../types";

export const useListViewModel = <R extends IRepository<any, any, any>>(
  RType: ObjectType<R>
) => {
  const resource = useResourceContext();
  type E = GetImplementedEntityType<R>;
  type S = GetImplementedSearchType<R>;
  type SP = GetImplementedSearchPaginatedType<R>;

  const repository = Container.resolve<R>(RType as any);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([] as E[]);
  const [dataPaginated, setDataPaginated] = useState({} as DomainPage<E>);

  const fetch = async (criteria: S) => {
    setLoading(true);

    await repository
      .get(criteria)
      .then((response: any) => setData(response))
      .finally(() => setLoading(false));
  };

  const getPaginated = async (criteria: SP) => {
    setLoading(true);

    await repository
      .getPaginated(criteria)
      .then((response: any) => setDataPaginated(response))
      .finally(() => setLoading(false));
  };

  const goToDetail = (id: string) => {
    navigate(`/${resource}/${id}`);
  };

  const create = () => {
    navigate(`/${resource}/create`);
  };

  const remove = async (id: string) => {
    await repository.remove(id);
  };

  return {
    data,
    dataPaginated,
    loading,
    fetch,
    getPaginated,
    goToDetail,
    create,
    remove,
  };
};
